module.exports = __webpack_public_path__ + "img/discord_clubhouse.8116be91.png";